module.exports = __webpack_public_path__ + "static/media/fly0035.45e14e55.webp";